import { DaghfalApp } from '@daghfal/core';
import '@daghfal/core/styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { strings } from './strings';

const container = document.getElementById('root');
if (!container) throw new Error('The #root element is missing from index.html.');

createRoot(container).render(
  <StrictMode>
    <DaghfalApp
      appKey="platform-console"
      appearance="console"
      // The platform console is coloured unlike any tenant surface, so that an operator working in both
      // is never in doubt about which system they are in (FR-PLT-01).
      surface="platform"
      catalogue={strings}
    >
      <App />
    </DaghfalApp>
  </StrictMode>,
);
